import type { FaireProductEntity } from "../../entity_types/product";

export const p_34xyv6zu5q: FaireProductEntity = {
  token: "p_34xyv6zu5q",
  type: "product",
  name: "C.C Solid Ribbed Infant Natural Fur Double Pom Pom Beanie",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl:
    "https://cdn.faire.com/fastly/b7c9916d6f153c9f50af2b524a517aa09b83dcbacf7f8ab72126fdbdfd11b243.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cab39fde50e7d48bb677cbd10336aeb9174393ad70c36dd742fc9bdc8b5beee4.jpeg",
    "https://cdn.faire.com/fastly/426948a901963f331bccdf723c931d5d1ab5993ab3557639cd38be2719c27274.jpeg",
    "https://cdn.faire.com/fastly/4ffb853047361412437fe43f463c534afe3904305e62046b69e85e6cbf8e7ec4.jpeg",
    "https://cdn.faire.com/fastly/f1efeba1dabb3544ffc5100109936e36e80275db9202f7377b3a82abe06bb132.jpeg",
    "https://cdn.faire.com/fastly/c1edd4a05d0c2677afd48d30b3face6c89455259ff2fe4c39702bda250ab7c61.jpeg",
    "https://cdn.faire.com/fastly/3cc000a5e7ec8d68d61320bca35ef2c06b71f206d7281c4787a719d621b41798.jpeg",
    "https://cdn.faire.com/fastly/6ce6f5be6e0259cced39ebfd93287ec76783e93eaeb38c312166af77be49b02a.jpeg",
    "https://cdn.faire.com/fastly/cd135123a69db0e7c1c5083d2ac169c07ea0bb03db5f5325fd989bb9eb75791b.jpeg",
  ],
  priceDollars: 9.5,
  description:
    'C.C Solid Ribbed Infant Natural Fur Double Pom Pom Beanie 14"-16" (35.56cm-40.64cm) 100% Acrylic Made in China',
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:40.611Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
